import { Switch } from "@/components/ui/switch";
import { useDevOverridesStore } from "@/lib/hooks/admin/use-dev-overrides";
import { useUserRecordsV2 } from "@/lib/hooks/use-user-records-v2";

export function UserRecordsV2Switch() {
  const enabled = useUserRecordsV2();
  const setUserRecordsV2Override = useDevOverridesStore(
    (state) => state.setUserRecordsV2Override,
  );

  return (
    <label className="inline-flex items-center gap-2 font-body text-sm font-medium text-text-secondary">
      New profile
      <Switch
        checked={enabled}
        onCheckedChange={(checked) =>
          setUserRecordsV2Override(checked ? "on" : "off")
        }
        aria-label="New profile"
      />
    </label>
  );
}
